'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Ellipsis;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Ellipsis(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-ellipsis ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M3,10 C1.8954305,10 1,9.1045695 1,8 C1,6.8954305 1.8954305,6 3,6 C4.1045695,6 5,6.8954305 5,8 C5,9.1045695 4.1045695,10 3,10 Z M8,10 C6.8954305,10 6,9.1045695 6,8 C6,6.8954305 6.8954305,6 8,6 C9.1045695,6 10,6.8954305 10,8 C10,9.1045695 9.1045695,10 8,10 Z M13,10 C11.8954305,10 11,9.1045695 11,8 C11,6.8954305 11.8954305,6 13,6 C14.1045695,6 15,6.8954305 15,8 C15,9.1045695 14.1045695,10 13,10 Z' })
  );
}

Ellipsis.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Ellipsis/Ellipsis.js
// module id = 213
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16